import { storage } from './storage.js';
import { account } from './account.js';

/* Pantallas de la cabecera del inicio que el servidor de Filoteca puede cambiar sin publicar una versión nueva de la app
   (ver server/hero.js). Se piden como mucho cada pocas horas, se guardan para el uso sin conexión y, si no hay nada, la
   app enseña las suyas de serie. El servidor responde con ETag, así que preguntar a menudo casi no cuesta. */

const KEY = 'heroSlides';
const TTL = 2 * 60 * 1000;

/** Servidor del que salen las pantallas: el de las actualizaciones en la app independiente, el de la cuenta en el resto. */
export function heroBase() {
    const u = typeof __UPDATE_URL__ !== 'undefined' ? String(__UPDATE_URL__).replace(/\/+$/, '') : '';
    return u || account.baseUrl();
}

/** Olvida lo guardado: la próxima visita al inicio vuelve a pedir las pantallas (lo usa el panel al guardar). */
export function forgetSlides() {
    storage.remove(KEY);
}

/** Las últimas pantallas guardadas ([] si nunca se pidieron). */
export function cachedSlides() {
    const c = storage.get(KEY);
    return c && Array.isArray(c.slides) ? c.slides : [];
}

/** Pide las pantallas al servidor (si toca o con `force`). Devuelve las nuevas, o null si no hubo cambio ni respuesta. */
export async function refreshSlides({ force = false, fetchImpl = (...a) => fetch(...a), now = Date.now } = {}) {
    const c = storage.get(KEY);
    if (!force && c && c.at && now() - c.at < TTL) return null;
    const ctl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timer = ctl ? setTimeout(() => ctl.abort(), 6000) : null;
    try {
        const r = await fetchImpl(heroBase() + '/api/hero', { cache: 'no-cache', signal: ctl ? ctl.signal : undefined });
        if (!r.ok) return null;
        const j = await r.json();
        if (!j || !Array.isArray(j.slides)) return null;
        const before = JSON.stringify(c && c.slides || []);
        storage.set(KEY, { at: now(), slides: j.slides });
        return JSON.stringify(j.slides) === before ? null : j.slides;
    } catch (e) {
        return null; // sin red: se sigue con lo guardado
    } finally {
        if (timer) clearTimeout(timer);
    }
}

/** Texto en el idioma pedido: el suelto vale para todos; si no, ese idioma, inglés, español o el primero que haya. */
export function pickText(v, lang) {
    if (typeof v === 'string') return v;
    if (!v || typeof v !== 'object') return '';
    const short = String(lang || '').slice(0, 2);
    return v[lang] || v[short] || v.en || v.es || Object.values(v)[0] || '';
}

/** Ruta del servidor → dirección completa (las imágenes se piden al mismo servidor que el manifiesto). */
export function heroUrl(p) {
    return /^\//.test(String(p || '')) ? heroBase() + p : '';
}
